export const getProductsFilterName = (key: string, type: string = ''): string => {
  return type ? `${type}.${key}` : key;
};

type formData = boolean[];
export const convertToIDArray = (data: formData) => {
  if (data.length === 0) {
    return undefined;
  } else if (!data[0]) {
    const IDArray = data.reduce((accumulator: number[], element: boolean, index: number) => {
      if (element && index !== 0) {
        accumulator.push(index);
      }
      return accumulator;
    }, []);
    return IDArray;
  } else {
    return undefined;
  }
};
